import { Chart } from "react-chartjs-2";
import { Chart as ChartJs } from "chart.js";
import { CountryPoint } from "../Analytics";
import * as ChartGeo from "chartjs-chart-geo";
import countryCodeToData from "../../../utils/countryCodeToData";
// @ts-ignore
import world from "world-atlas/countries-50m";
import { Table } from "antd";

const countries = ChartGeo.topojson.feature(
  world,
  world.objects.countries
  // @ts-ignore
).features;
ChartJs.register(
  ChartGeo.BubbleMapController,
  ChartGeo.ProjectionScale,
  ChartGeo.SizeScale,
  ChartGeo.GeoFeature
);
export const SessionsPerCountry = ({
  data,
}: {
  data?: Array<CountryPoint>;
}) => {
  const totalSessions = data?.reduce((sum, curr) => sum + curr.count, 0) || 1;
  const enhancedData = data?.map((item) => ({
    country: item.country,
    count: item.count,
    percentage: ((item.count / totalSessions) * 100).toFixed(2),
  }));
  const columns = [
    {
      title: "Country",
      dataIndex: "country",
      key: "country",
    },
    {
      title: "Sessions",
      dataIndex: "count",
      key: "count",
    },
    {
      title: "Percentage",
      dataIndex: "percentage",
      key: "percentage",
      render: (_: any, record: any) => {
        return `${record.percentage as number}%`;
      },
    },
  ];
  return data && enhancedData ? (
    <div className="map">
      <h2>Views per country</h2>
      <div className="country-view">
        <div className="tableView">
          <Table
            columns={columns}
            dataSource={enhancedData}
            scroll={{ y: 500 }}
          />
        </div>
        <div className="mapView">
          <Chart
            type="bubbleMap"
            options={{
              showOutline: true,
              showGraticule: false,
              plugins: {
                legend: {
                  display: false,
                },
              },
              scales: {
                xy: {
                  projection: "equalEarth",
                },
              },
            }}
            data={{
              labels: data.map((d) => countryCodeToData[d.country].country),
              datasets: [
                {
                  label: "Countries",
                  outline: countries,
                  showOutline: true,
                  backgroundColor: ["rgba(255, 89, 122, 0.6)"],
                  data: data.map((d) => ({
                    feature: countryCodeToData[d.country].country,
                    latitude: countryCodeToData[d.country].latitude,
                    longitude: countryCodeToData[d.country].longitude,
                    value: d.count,
                  })),
                },
              ],
            }}
          />
        </div>
      </div>
    </div>
  ) : null;
};
